<template>
  <div>
    <section id="footer-area" class="footer-area-section">
      <div class="container">
        <div class="footer-content pb10">
          <div class="row" v-if="projectName != 'JZYPXPT'">
            <div class="col-md-3" v-if="qrCodeURL">
              <div class="footer-widget">
                <h2 class="widget-title">微信{{isMiniQrCode ? '小程序' : '公众号'}}</h2>

                <div class="featured-course">
                  <div class="best-course-pic relative-position">
                    <img :src="qrCodeURL" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-5">
              <div class="footer-widget">
                <div class="footer-menu ul-li-block" :style="!qrCodeURL ? 'margin-left:0;' : ''">
                  <h2 class="widget-title">学习记录查询</h2>
                  <div class="listing-filter-form pb30">
                    <form action="#" method="get">
                      <div class="filter-select mb20">
                        <label>岗位</label>
                        <el-select v-model="model.JobId" placeholder="请选择">
                          <el-option v-for="item in courseJobs" :label="item.Name" :value="item.Id" :key="item.Id"></el-option>
                        </el-select>
                      </div>
                      <div class="filter-select mb20">
                        <label>姓名</label>
                        <input v-model="model.Name" type="text" class="" placeholder="同时填写身份证号">
                      </div>
                      <div class="filter-search mb20">
                        <label>身份证号</label>
                        <input v-model="model.IdNumber" type="text" class="" placeholder="同时填写姓名">
                      </div>
                      <el-button class="k-btn" style="margin-top:40px;width:126px;" @click="onStudyRecord">查&nbsp;&nbsp;询</el-button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="footer-widget">
                <h2 class="widget-title">联系我们</h2>
                <div v-if="projectName == 'NCJZJY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训咨询</span>
                    <span class="box-span">三类业务咨询 0791-85237783,<span style="margin-left:10px;">吴老师</span></span>
                    <span class="box-span">特种业务咨询 0791-85232080,<span style="margin-left:10px;">张老师</span></span>
                    <span class="box-span">技术工人咨询 0791-85237783,<span style="margin-left:10px;">汤老师</span></span>
                    <span class="box-span">十大员业务咨询 0791-85207925,<span style="margin-left:10px;">王老师</span></span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">缴费咨询</span>
                    <span class="box-span">QQ群：522613867</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">地址</span>
                    <span class="box-span">南昌市井冈山大道842号</span>
                  </div>
                </div>
                <div v-if="projectName == 'FZSJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训咨询</span>
                    <span class="box-span">三类业务咨询 0794-8263186,<span style="margin-left:10px;">陈老师</span></span>
                    <span class="box-span">特种业务咨询 0794-8233186,<span style="margin-left:10px;">阮老师</span></span>
                    <span class="box-span">财务咨询 0794-8243186,<span style="margin-left:10px;">易老师</span></span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号</span>
                    <span class="box-span" style="line-height:24px;">
                      户名：抚州市赣东职业技能培训学校有限公司<br>
                      开户行：交通银行股份有限公司抚州分行<br>
                      账号：473899991011000121061<br>
                    </span>
                  </div>
                </div>
                <div v-if="projectName == 'JASJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训学校咨询电话</span>
                    <span class="box-span">咨询电话：0796-8245935</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">培训学校地址</span>
                    <span class="box-span">吉安市吉州区跃进路23号建安大厦2楼205室</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号</span>
                    <span class="box-span" style="line-height:24px;">
                      户名：吉安市吉州区众合职业技能培训学校有限公司<br>
                      开户行：上饶银行吉州支行<br>
                      账号：231603090000000768<br>
                    </span>
                  </div>
                </div>
                <div v-if="projectName == 'JXJYJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训咨询</span>
                    <span class="box-span">0791-87302659,87302656</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">办公地址</span>
                    <span class="box-span">江西省南昌小蓝经济开发区汇仁大道999号</span>
                    <span class="box-span">邮编：330200</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号</span>
                    <span class="box-span">户名： 江西建设职业技术学院</span>
                    <span class="box-span">开户行： 中国工商银行红谷滩支行</span>
                    <span class="box-span">账号： 1502210009026401379</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">企业联系群</span>
                    <span class="box-span">“三类人员”QQ群号: 174364310</span>
                    <span class="box-span">“特种作业”QQ群号: 113450009</span>
                  </div>
                </div>
                <div v-if="projectName == 'COURAGETECH'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训咨询</span>
                    <span class="box-span">18657171556,<span style="margin-left:10px;">万先生</span></span>
                  </div>
                </div>
                <div v-if="projectName == 'JJSJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训业务咨询电话</span>
                    <span class="box-span">
                      业务咨询 0792-8983375<br>
                      财务咨询 0792-8983375<br>
                    </span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">办公地址</span>
                    <span class="box-span">江西省九江市长虹大道检测大楼五楼培训管理科办公室</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号（初次培训缴费账号）</span>
                    <span class="box-span">
                      户名：九江市利安建设工程安全技术咨询服务有限公司<br>
                      开户行：中国农业银行九江分行长虹支行<br>
                      账号：14047601040005589<br>
                    </span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">企业联系群</span>
                    <span class="box-span">
                      QQ群：213487818<br>
                    </span>
                  </div>
                </div>
                <div v-if="projectName == 'YCSJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训业务咨询</span>
                    <span class="box-span">八大员培训业务咨询：13672277818</span>
                    <span class="box-span">企业注册、三类特种培训业务：0795-3215881</span>
                    <span class="box-span">财务咨询：18907958730</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">办公地址</span>
                    <span class="box-span">
                      江西省宜春市秀江东路15号
                    </span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号</span>
                    <span class="box-span">
                      户名：宜春市国控职业技能培训学校有限责任公司<br>
                      开户行：中国银行股份有限公司宜春市袁州新城支行<br>
                      账号：200757001584<br>
                    </span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">企业交流群</span>
                    <span class="box-span">
                      QQ群号: 516293944
                    </span>
                  </div>
                </div>
                <div v-if="projectName == 'JJSZJPX'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">咨询电话</span>
                    <span class="box-span">培训咨询电话：0792-7773952</span>
                    <span class="box-span">财务咨询电话：0792-8983325，15374235198</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">办公地址</span>
                    <span class="box-span">九江经济技术开发区城西港区港城大道86号</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">缴费账号</span>
                    <span class="box-span">账户名：九江经开区天平职业技能培训学校有限公司</span>
                    <span class="box-span">开户行：中国工商银行股份有限公司九江浔中支行</span>
                    <span class="box-span">账号：1507210009200077414</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">联系群</span>
                    <span class="box-span">培训工作联系QQ群：1062480578</span>
                    <span class="box-span">九江燃气培训QQ群：1062480578</span>
                  </div>
                </div>
                <div v-if="projectName == 'XYSJZY'" class="featured-course">
                  <div class="box-lx">
                    <span class="box-title">培训考试咨询电话</span>
                    <span class="box-span">0790-6456096、13755559626<span style="margin-left:10px;">王老师、范老师</span></span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">办公地址</span>
                    <span class="box-span">新余市总工会职工之家一楼大厅（仙来西大道29号）</span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">对公账号</span>
                    <span class="box-span" style="line-height:24px;">
                      户名：新余市特安职业技能服务中心<br>
                      开户行：中国银行新余市毓秀支行<br>
                      账号：194744661739<br>
                    </span>
                  </div>
                  <div class="box-lx">
                    <span class="box-title">企业联系群</span>
                    <span class="box-span">
                      QQ号: 2983420366
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters, ProjectSettings } from '@/views/base/base.js'
export default {
  data() {
    return {
      model: {
        JobId: null,
        Name: null,
        IdNumber: null
      },
      projectName: ProjectSettings.Name,
      qrCodeURL: ProjectSettings.WeiXinURL,
      isMiniQrCode: ProjectSettings.IsMiniQrCode
    }
  },
  computed: {
    ...mapGetters({
      courseJobs: 'getCourseJobs'
    })
  },
  mounted() {
    this.$store.dispatch('getCourseJobs', { courseId: 5 });
  },
  methods: {
    onStudyRecord(id) {
      let that = this;
      if (!this.model.JobId) {
        this.$alert('请选择查询岗位', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (!this.model.Name) {
        this.$alert('请输入查询姓名', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (!this.model.IdNumber) {
        this.$alert('请输入查询身份证', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      this.$store.dispatch('getStudyRecordDetails', this.model).then((res) => {
        if (res.MsgCode !== 0) {
          this.$alert(res.Message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
          return;
        }
        that.$router.push({ name: 'studyrecord', query: { JobId: that.model.JobId, Name: that.model.Name, IdNumber: that.model.IdNumber } });
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.box-lx {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .box-title {
    font-size: 16px;
    font-weight: 700;
    color: 700;
    color: #333333;
    margin-bottom: 0.5rem;
  }
  .box-span {
    font-size: 16px;
    font-weight: 400;
    color: 700;
    color: #333333;
    margin-bottom: 0.5rem;
  }
}

.listing-filter-form label {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/weixin.vue